import React, {Component} from "react";
import axios from "axios";
import { CategoryData } from "../components/CategoryData";
import { DetailArticle as ComponentDetailArticle } from "../components/DetailArticle";
import ReactLoading from "react-loading";
import PageNav from "../partials/PageNav";

class DetailArticle extends Component{

    state = {
        articles : [],
        article : false,
        categories : [],
        comments : [],
        name : "",
        email : "",
        website : "",
        comment : "",
        error : ""
    }

    handleInput = (e) => {
        this.setState({
            click : false,
            [e.target.name]: e.target.value
        });
    }

    async getArticles (){
        let articles = await axios.get('articles')
        if(articles.status == 200){
            this.setState({ articles : articles.data })
        }
    }

    async getComments (){
        let comments = await axios.get(`comments/${ this.props.match.params.id }`)
        if(comments.status == 200){
            this.setState({ comments : comments.data })
        }
    }


    async getArticle (){
        let article = await axios.get(`articles/${ this.props.match.params.id }`)
        if(article.status == 200){
            this.setState({ article : article.data })
        }
    }

    async getCategories (){
        let categories = await axios.get('categories')
        if(categories.status == 200){
            this.setState({ categories : categories.data })
        }
    }

    componentDidMount(){
        this.getArticle()
        this.getArticles()
        this.getComments()
        this.getCategories()
        this.refreshToken()
        window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
    }

    async refreshToken () {
        try{
          var token = await axios.get('token');
          if(token.status === 200)
          {
              var user = (token.data.data);
              localStorage.setItem("user", JSON.stringify(user));
          }
          else if(token.status === 401)
          {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
          }
        }catch(error) {
            axios.delete('logout').then((re) => { console.log("disconnect") }).catch((erro) => { console.log("error") });
            window.localStorage.clear();
        }
    }

    saveComment = async () => {
        this.setState({  click : true, error : ""})
        let formData = {
            articleId : this.props.match.params.id, 
            userId : null, 
            name : this.state.name,
            email : this.state.email,
            website : this.state.website,
            comment : this.state.comment
        }
        axios.post('comments', formData).then((response) => {
            window.scrollTo({top: 0, left: 0, behavior: 'smooth'});
            this.setState({
                error : "",
                name : "",
                email : "",
                website : "",
                comment : "",
                click : false
            })
            this.getComments()
            // window.location.replace(process.env.REACT_APP_BEYEGROUP + "/articles/" + this.props.match.params.id);
        }).catch((error) => {
            this.setState({
                error : error.response.data.msg,
                click : false
            })
        })
    }

    render(){
        let pagenav = PageNav( this.state.article ? ( this.state.article.category.name + " " + this.state.article.title ) : "" ,  "/articles/" + this.props.match.params.id,  "/logo192.png",   this.state.article ? ( this.state.article.category.name  ) : "",  this.state.article ? ( this.state.article.title ) : "");
        return(
            
            <main id="main">
                <div>{ pagenav }</div>
                
                <section id="blog" className="blog">
                    <div className="container p-0" data-aos="fade-up">

                        <div className="row">
                            <div className="col-md-9">
                            {
                                this.state.article && (
                                    <div>
                                        <ComponentDetailArticle article={ this.state.article } comment={ this.state.comments.length} categories={ this.state.categories.filter((cat => cat.parentId == null)) } />
                                        
                                        <div className="mt-5 pt-5">
                                        {
                                            this.state.article.comment == 1 && (
                                                <div className="comments">

                                                    <h4 className="comments-count">{ this.state.comments.length > 1 ? this.state.comments.length + " Commentaires" : this.state.comments.length + " Commentaire" }</h4>

                                                    {
                                                        this.state.comments.map(comment => {
                                                            return(
                                                                <div id="comment-1" className="comment" key={comment.id}>
                                                                    <div className="d-flex">
                                                                        <div className="comment-img"><img src={ comment.user.avatar ? comment.user.avatar :  "/img/avatar.jpg" } alt={ comment.name } title={ comment.name } /></div>
                                                                        <div className="border border-1 px-3  overflow-hidden  rounded-4 py-2">
                                                                            <div className="h-6 text-dark font-12 font-monospace fw-normal"> { comment.name } </div>
                                                                            <p>
                                                                                { comment.comment }
                                                                            </p>
                                                                            <div className="text-end"><time dateTime={ new Date(comment.createdAt).toDateString()}><small>{ new Date(comment.createdAt).toDateString() }</small></time></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                        
                                                    <div className="reply-form">

                                                        <h4>Votre commentaire</h4>
                                                        <form action="#">
                                                            <div className="row">
                                                                <div className="text-danger">{ this.state.error }</div>
                                                                <div className="col-md-6 form-group">
                                                                <input name="name" onChange={this.handleInput} type="text" className="form-control" placeholder="Votre Name*" />
                                                                </div>
                                                                <div className="col-md-6 form-group">
                                                                <input name="email" onChange={this.handleInput} type="text" className="form-control" placeholder="Votre Email*" />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col form-group">
                                                                <input name="website" onChange={this.handleInput} type="text" className="form-control" placeholder="Votre Website" />
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col form-group">
                                                                <textarea name="comment" onChange={this.handleInput} className="form-control" placeholder="Votre Commentaire*"></textarea>
                                                                </div>
                                                            </div>
                                                            <div className="text-end"><button type="button" disabled={this.state.click} onClick={ () => this.saveComment() } className="btn btn-white" style={{ backgroundColor : '#dc2751', color : 'white'}}>Enregister { !this.state.click ? <i className="bi bi-check font-20 ms-1"></i> : <ReactLoading type="spokes"  className="float-end text-orangered" height={15} width={15} />}</button></div>
                                                        </form>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        </div>
                                    </div>
                                )
                            }
                            </div>
                            <div className="col-md-3">
                                <CategoryData categories={ this.state.categories } articles={ this.state.articles.sort((a, b) => a.createdAt < b.createdAt ? 1 : -1 ).filter( data => data.comment != 3).slice(0, 5) } />
                            </div>
                        </div>
                    </div>
                </section>
            </main> 
        )
    }
}
export default DetailArticle;